export default {
      id: "common__track_day-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__track_day",
      toString: function () {
        return this.url;
      }
    }